import { render, staticRenderFns } from "./User_service_agreement.vue?vue&type=template&id=e2f895fc&scoped=true"
import script from "./User_service_agreement.vue?vue&type=script&lang=js"
export * from "./User_service_agreement.vue?vue&type=script&lang=js"
import style0 from "./User_service_agreement.vue?vue&type=style&index=0&id=e2f895fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f895fc",
  null
  
)

export default component.exports